// Create a copy of "dev.env" file and rename to ".env", then ensure
// all variable are for dev environment

export default {
  BACKEND_API_URL: process.env.REACT_APP_BACKEND_API_URL,
  RECAPTCHA_SITEKEY: process.env.REACT_APP_RECAPTCHA_SITEKEY,
  PAYMENT_EMAIL_API_URL: process.env.REACT_APP_PAYMENT_EMAIL_API_URL,
  STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
};
